"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_virtualized_1 = require("react-virtualized");
var constants_1 = require("../../constants");
var useCellMeasurerCache = function (rowHeight) {
    // eslint-disable-next-line
    var cache = new react_virtualized_1.CellMeasurerCache({
        fixedWidth: true,
        minHeight: rowHeight || constants_1.ROW_HEIGHT
    });
    var updateCache = (0, react_1.useCallback)(function () {
        cache.clearAll();
    }, [cache]);
    (0, react_1.useEffect)(function () {
        window.addEventListener('resize', updateCache);
        return function () {
            window.removeEventListener('resize', updateCache);
        };
        // eslint-disable-next-line
    }, []);
    return cache;
};
exports.default = useCellMeasurerCache;
